export default __webpack_public_path__ + "static/media/comercialmexicana.7b365175.png";